import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/topbar.css';

export default function Topbar({ user, onLogout, onMenuClick }) {
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const [date, setDate] = useState('');
  const [dropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    const updateDate = () => {
      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      setDate(new Date().toLocaleDateString('en-US', options));
    };
    updateDate();
    const interval = setInterval(updateDate, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }

    if (dropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [dropdownOpen]);

  return (
    <header className="topbar">
      <div className="topbar-left">
        <button className="menu-button" onClick={onMenuClick} title="Menu">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </button>
        <div className="topbar-logo">
          <img src="/mustechlogo.png" alt="Mustech" className="topbar-logo-image" />
        </div>
        <div className="entity-info">
          <h2 className="entity-name">Mustech Bulk SMS</h2>
          <p className="date">{date}</p>
        </div>
      </div>

      <div className="topbar-right">
        <div className="topbar-dropdown" ref={dropdownRef}>
          <button className="topbar-icon" onClick={() => setDropdownOpen(!dropdownOpen)} title="Account">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
              <circle cx="12" cy="7" r="4" />
            </svg>
          </button>
          {dropdownOpen && (
            <div className="dropdown-menu">
              <a href="#profile" onClick={() => { navigate('/dashboard/profile'); setDropdownOpen(false); }}>Profile</a>
              <a href="#settings" onClick={() => { navigate('/dashboard/settings'); setDropdownOpen(false); }}>Settings</a>
              <hr />
              <a href="#logout" onClick={() => { onLogout(); setDropdownOpen(false); }} className="logout-link">Logout</a>
            </div>
          )}
        </div>

        <button className="topbar-icon" title="Settings" onClick={() => navigate('/dashboard/settings')}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="3" />
            <path d="M12 1v6m0 6v6M4.22 4.22l4.24 4.24m5.08 5.08l4.24 4.24M1 12h6m6 0h6M4.22 19.78l4.24-4.24m5.08-5.08l4.24-4.24" />
          </svg>
        </button>
      </div>
    </header>
  );
}
